// Vendor
import 'bootstrap';
import 'flickity';
import 'flickity-imagesloaded';
import 'flickity-as-nav-for';
import 'flickity-fade';
import 'jarallax';

// Theme
import './aos';
import './bigpicture';
import './bootstrap';
//import './choices';
import './countup';
//import './dropzone';
import './flickity';
import './highlight';
import './isotope';
import './jarallax';
//import './map';
import './modal';
import './navbar-dropdown';
import './navbar';
import './popover';
import './pricing';
//import './quill';
import './smooth-scroll';
import './tooltip';
import './typed';


var $ = require('jquery');
window.jQuery = $;
window.$ = $;
/*let pagesBlackNavbar = ['politique-de-confidentialite','cgv','userguide','abonnement','evenement','mentionslegales'];
const mRegex = RegExp(pagesBlackNavbar.join("|"));
if (mRegex.test(window.location.href))
	document.querySelector("#msys-navbar").classList.add("bg-black");
*/	
 $(".nav-link").click(function () {
	$('#navbarCollapse').collapse('hide');
});

$(".article-userguide").on('click', function (e) {
	
	e.preventDefault();
	$('#'+$(this).attr('data-controls')).toggle();
	setTimeout(function(){
		//$(this)[0].scrollIntoView(true);	
	}, 100);
	setTimeout(function(){
		$('html, body').animate({
			//scrollTop: $(window).scrollTop() - ($('#msys-navbar').outerHeight() + 10)
		});
	}, 200);
});

$('.collapsed').hide();

/*
window.onscroll = function() {
	
	 var t = window.pageYOffset;
	 var e = document.querySelector("#msys-navbar");
	 if(t>0){
		 e.classList.add("bg-black");
	 }
	 else{
		 if(!mRegex.test(window.location.href))
			e.classList.remove("bg-black");
	 }
};
*/
if(document.querySelector('.prevent')!=null)
	document.querySelector('.prevent').addEventListener("click", function(event){
//	  event.preventDefault();
	});

if(document.querySelector('.m-breadcrumb')!=null){
//	document.querySelector('.m-breadcrumb').style.marginTop = document.querySelector('#msys-navbar').offsetHeight+'px';
}

$('.copyright-year').html((new Date()).getFullYear());


